// Public route component (redirects to dashboard if already authenticated)
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@hooks';
import { ROUTES } from '@constants';
import { isFullyAuthenticated } from '@utils';

export const PublicRoute = () => {
  const { isAuthenticated, isLoading, authProvider, orySession } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block h-12 w-12 animate-spin rounded-full border-b-2 border-sf-blue" />
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  const fullyAuthenticated = isFullyAuthenticated({
    isAuthenticated,
    authProvider,
    assuranceLevel: orySession?.session.authenticator_assurance_level,
  });

  return fullyAuthenticated ? <Navigate to={ROUTES.DASHBOARD} replace /> : <Outlet />;
};
